/**
 * CellBadge — an item's cell: its primary category × its altitude, drawn as
 * two square tags (Square/Mono). The item page shows it in its header.
 *
 * Moved here from the Item Detail second-pass Lab page
 * (features/item-detail-second-pass/ItemDetailSecondPassLab.tsx), which
 * re-exports it, so the product's item page no longer imports from a Lab file
 * (Proposal 09 § 4, coupling 1). Markup unchanged.
 */
/** `tag` is the name that follows the number ("Altitude 3 · Epic"): the Method's name for the level. */
export function CellBadge({ category, altitude, tag }: { category: string; altitude: number; tag?: string | null }) {
  return (
    <span className="inline-flex items-stretch font-mono text-[12px] uppercase tracking-[0.07em]" title="Primary category × altitude">
      <span className="border bg-[var(--slate-dim)] px-2.5 py-1 text-[var(--text-sec)]" style={{ borderColor: 'var(--slate)' }}>
        {category}
      </span>
      <span className="px-1.5 py-1 text-[var(--text-dim)]">×</span>
      <span className="border px-2.5 py-1 text-[var(--mustard)]" style={{ borderColor: 'var(--mustard)' }}>
        Altitude {altitude}{tag ? ` · ${tag}` : ''}
      </span>
    </span>
  );
}
